var accordionInit;

(function ($) {

	const selectors = {
		wrap: '[data-accordions]',
		accordion: '[data-accordion]',
		trigger: '[data-accordion-trigger]',
		content: '[data-accordion-content]',
	}

	accordionInit = function () {
		$(selectors.wrap).each((i, el) => {
			new Accordion(el);
		});
	}

	class Accordion {
		constructor(element) {
			this.$wrap = $(element);

			this.init();


		}
		init() {
			this.$accordions = this.$wrap.find(selectors.accordion);
			this.$triggers = $(selectors.trigger, this.$accordions).not(this.$wrap.find(selectors.wrap).find(selectors.trigger));
			this.$contents = $(selectors.content, this.$accordions).not(this.$wrap.find(selectors.wrap).find(selectors.content));
			this.allowMultiple = this.$wrap.attr('data-allow-multiple') !== undefined;
			this.delay = this.$wrap.attr('data-delay') ? this.$wrap.attr('data-delay') : 0;

			this.bind();

			if (this.$wrap.attr('data-open-first') !== undefined) {
				this.$triggers.eq(0).trigger('click');
			}

		}

		bind() {

			const self = this;

			this.onTriggerClicked = this.onTriggerClicked.bind(this);
			this.$triggers.on('click', function (e) { e.preventDefault(); self.onTriggerClicked(this); });
		}

		onTriggerClicked(link) {
			var $acc = $(link).closest(selectors.accordion);
			$acc.hasClass('is-active') ? this.hide($acc) : this.show($acc);
		}

		show($acc) {

			if ($acc.hasClass('is-active')) return;

			const self = this;

			if (!this.allowMultiple) {
				setTimeout(() => {
					this.$accordions.not($acc).each((i, acc) => {
						self.hide($(acc));
					});

				}, self.delay);

			}

			$acc.addClass('is-active').find(this.$contents).stop().delay(self.delay).slideDown();

		}

		hide($acc) {
			if (!$acc.hasClass('is-active')) return;
			$acc.removeClass('is-active').find(this.$contents).stop().delay(self.delay).slideUp();
		}

	}

})(jQuery);


export default accordionInit;